import { CLOSE, OPEN, PROCEDURE_SELECTION_TYPE } from '../../utils/constants';
import {
    form,
    procedures,
    selectedProcedures,
    setSelectedProcedures,
    procedureSelectionType,
    visitorId,
} from '../../utils/variables';
import { params } from '../events/movePages';
import { removeAllAddons } from './addonActions';
import { updateVisitorAction } from '../../services/visitorServices';

export function addProcedure(id) {
    if (visitorId) {
        updateVisitorAction(visitorId, 'selected-service', {
            procedure_id: id,
        }).catch(error => {
            console.error('Failed to track procedure selection:', error);
        });
    }

    if (procedureSelectionType === PROCEDURE_SELECTION_TYPE.SINGLE) {
        removeAllProcedures();
    }
    if (
        form?.procedures_max_num_of_selection &&
        selectedProcedures.length === form.procedures_max_num_of_selection
    ) {
        return;
    }

    let proceduresArr = [...selectedProcedures, id];

    setSelectedProcedures(proceduresArr);

    /* Change the checkbox */
    const inputChecks = document.querySelectorAll(
        `.procedure__checkbox[data-procedure-id=${CSS.escape(id)}]`
    );
    inputChecks.forEach((i) => i.classList.add('is-checked'));

    /* Change the Add/Remove Procedure button */
    const btn = document.querySelectorAll(
        `.procedure-body__add-procedure-btn[data-procedure-id=${CSS.escape(
            id
        )}]`
    );
    btn.forEach((i) => (i.textContent = 'Remove Procedure'));

    checkSelectedProceduresToEnableConsultationBtn();

    /* Check subProcedures to disable another procedure */
    const procedure = procedures.find((i) => i.id === id);
    const subProceduresId = procedure ? (procedure.sub_procedures?.map((i) => i.id) || []) : [];

    for (const i of subProceduresId) {
        let selectedSubProocedures = document
        .querySelectorAll(
            `.line__wrapper.procedure[data-procedure-id=${CSS.escape(i)}]`
        );
        if(selectedSubProocedures && selectedSubProocedures?.length > 0) {
            selectedSubProocedures.forEach(selectedSubProocedure => {
                if (selectedSubProocedure) {
                    selectedSubProocedure
                    .classList.add('disabled');
                }
            });
        }
        addDescriptionWhenProcedureDisabled(i, procedure.name);
    }
}

export function removeProcedure(id) {
    let proceduresArr = selectedProcedures.filter((i) => i !== id);

    setSelectedProcedures(proceduresArr);

    /* Change the checkbox */
    const inputChecks = document.querySelectorAll(
        `.procedure__checkbox[data-procedure-id=${CSS.escape(id)}]`
    );
    inputChecks.forEach((i) => i.classList.remove('is-checked'));

    /* Change the Add/Remove Procedure button */
    const btn = document.querySelectorAll(
        `.procedure-body__add-procedure-btn[data-procedure-id=${CSS.escape(
            id
        )}]`
    );
    btn.forEach((i) => (i.textContent = 'Add Procedure'));

    checkSelectedProceduresToEnableConsultationBtn();

    /* Check subProcedures to enable another procedure */
    let  selectedProcedure = procedures.find((i) => i.id === id);
    const subProcedures = selectedProcedure ? selectedProcedure.sub_procedures.map((i) => i.id) : [];
    for (const i of subProcedures) {
        let selectedSubProocedures = document
        .querySelectorAll(
            `.line__wrapper.procedure[data-procedure-id=${CSS.escape(i)}]`
        );
        if(selectedSubProocedures && selectedSubProocedures?.length > 0) {
            selectedSubProocedures.forEach(selectedSubProocedure => {
                if (selectedSubProocedure) {
                    selectedSubProocedure
                    .classList.remove('disabled');
                }
            });
        }
    }
}

export function removeAllProcedures() {
    for (const i of selectedProcedures) {
        removeAllAddons(i);
    }

    setSelectedProcedures([]);

    /* Change the checkbox */
    const inputChecks = document.querySelectorAll(`.procedure__checkbox`);
    inputChecks.forEach((i) => i.classList.remove('is-checked'));

    /* Enable all procedures */
    document
        .querySelectorAll(`.line__wrapper.procedure`)
        .forEach((i) => i.classList.remove('disabled'));

    checkSelectedProceduresToEnableConsultationBtn();
}

export function isCheckedProcedure(id) {
    if (selectedProcedures.find((i) => i === id)) {
        return true;
    }
    return false;
}

export function toggleProcedureDescription(id, state) {
    const descriptionWrapper = document.querySelector(
        `.procedureBody__wrapper[data-procedure-id="${CSS.escape(id)}"]`
    );
    if (state === OPEN) {
        descriptionWrapper.classList.add('popup__open');

        descriptionWrapper.querySelector('.popup__background').classList.remove('fadeOut');
        descriptionWrapper.querySelector('.popup__background').style.willChange = 'opacity';
        descriptionWrapper.querySelector('.popup__background').addEventListener('animationend', () => {
            descriptionWrapper.querySelector('.popup__background').style.willChange = 'auto';
        }, { once: true });
        descriptionWrapper.querySelector('.popup__background').classList.add('fadeIn');
        
        descriptionWrapper.querySelector('.procedureBody__content').classList.remove('fadeOutDown');
        descriptionWrapper.querySelector('.procedureBody__content').style.willChange = 'transform, opacity';
        descriptionWrapper.querySelector('.procedureBody__content').addEventListener('animationend', () => {
            descriptionWrapper.querySelector('.procedureBody__content').style.willChange = 'auto';
        }, { once: true });
        descriptionWrapper.querySelector('.procedureBody__content').classList.add('fadeInUp');
    } else if (state === CLOSE) {
        descriptionWrapper.querySelector('.procedureBody__content').addEventListener('animationend', () => {
            descriptionWrapper.querySelector('.procedureBody__content').style.willChange = 'auto';
            descriptionWrapper.querySelector('.popup__background').style.willChange = 'auto';
            descriptionWrapper.classList.remove('popup__open');
        }, { once: true });

        descriptionWrapper.querySelector('.popup__background').classList.remove('fadeIn');
        descriptionWrapper.querySelector('.popup__background').style.willChange = 'opacity, visibility';
        descriptionWrapper.querySelector('.popup__background').classList.add('fadeOut');

        descriptionWrapper.querySelector('.procedureBody__content').classList.remove('fadeInUp');
        descriptionWrapper.querySelector('.procedureBody__content').classList.add('fadeOutDown');
    }
}

function addDescriptionWhenProcedureDisabled(disableId, procedureName) {
    const disableProcedure = document.querySelectorAll(
        `.line__wrapper.procedure[data-procedure-id=${CSS.escape(
            disableId
        )}] .procedure__disableText`
    );
    disableProcedure.forEach((i) => {
        i.innerHTML = `Cannot select this procedure if <b>${procedureName}</b> is selected`;
    });
}

export function checkSelectedProceduresToEnableConsultationBtn() {
    const consultBtn = document.querySelector('.procedureContinue__btn');
    if (selectedProcedures.length > 0) {
        consultBtn.removeAttribute('disabled');
        if (params('mobile')) {
            document.querySelector('.seeServices__container .screen__content > .procedure__actions')?.classList.remove('hide');
        }
    } else {
        consultBtn.setAttribute('disabled', true);
        if (params('mobile')){
            document.querySelector('.seeServices__container .screen__content > .procedure__actions')?.classList.add('hide');
        }
    }

}
